import useStore,{StoreState} from "../context/useStore";
import { Property } from "../types/Property.interface";
import { Response } from "../types/Response.interface";

import { apiClient } from "../utils/apiClient";

export const useFeature = (property: Property) => {
  const auth = useStore((state: StoreState) => state.auth)
  const setDialog = useStore((state: StoreState) => state.setDialog)
  const setProperties = useStore((state: StoreState) => state.setProperties)
  
  const onFeature = async () => {
    if (!auth.login) {
      setDialog({
        closable: true,
        open: true,
      })
      return;
    }

    const res: Response = await apiClient.post("/api/v1/featured", {
      mls: property.ListingKey,
    });
    if (res.ok) {
      setProperties(res.data)
    }
  };

  return {
    onFeature,
  };
};
